import { render, staticRenderFns } from "./cartComponent.vue?vue&type=template&id=1d6a8c3f&scoped=true&"
import script from "./cartComponent.vue?vue&type=script&lang=js&"
export * from "./cartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6a8c3f",
  null
  
)

export default component.exports